<template>
    <div class="layout-comp" :class="{ 'game-style': pathHeight, 'no-bottom': !showBottom }">
        <div class="top-nav">
            <div class="nav-content clearfix">
                <div class="left-sec fl">
                    <span @click="changeNav(item)" :class="{ active: active == item.id }" v-for="item in navList" :key="item.id">
                        <i>{{ item.name }}</i>
                        <!-- 暂时隐藏、后续打开 -->
                        <!--<template v-if="item.id === 2">
                            <div @click.stop="openAct" class="group-buy-sec"></div>
                        </template>-->
                    </span>
                </div>
                <div class="search-wrap fl" v-click-outside="handlerClickOutside">
                    <search-input :width="370" :empty-can-search="true" @input="debounceInput" @searchClick="debounceInput" @clear="resetSearchFilter" :emptyCanSearch="true" @focus="handerFocus"></search-input>
                    <transition name="slide-down">
                        <div class="search-result hide-scroll" v-show="showResult">
                            <SearchGameItem class="item" type="box-game-index" v-for="item in gameList" :key="item.id" :game-info="item"></SearchGameItem>
                            <div class="search-inner">
                                <div class="loading-wrap">
                                    <DataLoader size="small" :loading="loading" :data="gameList"></DataLoader>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="hot-inner">
                                <div class="hot-title">近期热搜：</div>
                                <SearchGameItem class="item" type="game-index" v-for="item in hotGameList" :key="item.id" :game-info="item"></SearchGameItem>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="user-sec fr" v-if="showBottom">
                    <div class="user-avatar" :class="{ 'not-login': !isLogin }" @click="goToProfile">
                        <img v-if="avatar && isLogin" :src="avatar" alt="" />
                    </div>
                    <div v-if="isLogin" class="quit-bt" @click="quitClick">退出登录</div>
                </div>
                <div class="right-btn fr">
                    <div class="dl-btn" @click="dlClient" data-agl-cvt="6">安装客户端</div>
                    <div :class="{ 'act-top-icon': true, hide: !showActFixedIcon }" @click="actBenefitClick(0)"></div>
                </div>
                <div class="how-to-play fr" @click="goToHowToPlay">如何启动游戏</div>
            </div>
        </div>
        <router-view></router-view>
        <div class="right-bottom-ads" v-if="$route.path !== '/game'">
            <swiper @click-slide="handlerClickSlide" :options="swiperOption" @slideChangeTransitionStart="slideChangeTransitionStart">
                <swiper-slide v-for="item in swiperDataList" :key="item.id" class="swiper-no-swiping">
                    <template v-if="item.id === 1">
                        <div class="get-free-game-act">
                            <span class="tip" v-if="messageNum > 0">{{ messageNum }}</span>
                        </div>
                    </template>
                    <template v-else-if="item.id === 2">
                        <div class="group-buy-vip-act">
                            <span class="tip" v-if="messageNum > 0">{{ messageNum }}</span>
                        </div>
                    </template>
                </swiper-slide>
            </swiper>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>
<script>
import mixin from '../mixin.js'
import config from '@/http/config'
import { mapState, mapGetters } from 'vuex'
import { gameDatabase, getHotGameList } from '@/http/api/game'
import { cancelRequest } from '@/http'
import { getCookieToken, removeCookieToken } from '@/utils/auth'

const baidudyy = [
    { id: 1, path: '/', name: '首页' },
    { id: 3, path: '/game', name: '游戏库' }
]

const defaultNav = [
    { id: 1, path: '/', name: '首页' },
    { id: 2, path: '/vip', name: '会员中心' },
    { id: 3, path: '/game', name: '游戏库' }
]

export default {
    name: 'LayoutComp',
    mixins: [mixin],
    data() {
        const that = this
        return {
            active: 0,
            navList: [...defaultNav],
            defautlAvatar: require('@/assets/default.png'),
            showResult: false,
            query: {
                page: 1,
                size: 4,
                name: '',
                mode: 1
            },
            loading: false,
            loadingFinish: false,
            loadingError: false,
            gameList: [],
            hotGameList: [],
            swiperDataList: [
                {
                    id: 1,
                    name: '限时领取免费游戏'
                }
                // 暂时隐藏，后续打开
                /*{
                    id: 2,
                    name: '会员拼团'
                }*/
            ],
            swiperOption: {
                initialSlide: 0,
                direction: 'horizontal',
                loop: false,
                touchMove: false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                on: {
                    init: function () {
                        that.swiperInstance = this
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            },
            activeSwiperIndex: 0
        }
    },
    computed: {
        ...mapState(['userInfo', 'landpageDl']),
        ...mapGetters(['showBottom', 'messageNum']),
        isLogin: function () {
            return this.userInfo.id
        },
        avatar: function () {
            const avatar = this.userInfo.avatar
            if (!avatar) {
                return this.defautlAvatar
            } else if (avatar.indexOf('thirdwx.qlogo.cn') > -1) {
                return avatar
            } else {
                return config.PREVIEW_DOMAIN + avatar
            }
        },
        pathHeight() {
            return this.$route.path === '/game'
        },
        showActFixedIcon() {
            return true
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(current) {
                const curNav = this.navList.find((v) => v.path === current.path)
                if (curNav) {
                    this.active = curNav.id
                } else {
                    this.active = 0
                }

                window.scrollTo(0, 0)
            }
        }
    },
    created() {
        if (this.showBottom) {
            this.navList = defaultNav
        } else {
            this.navList = baidudyy
        }

        this.debounceInput = this.debounce(this.handlerSearch, 200)
        this.$EventBus.$on('hide-search', () => (this.showResult = false))
        this.$EventBus.$on('dl-client', (payload) => {
            this.dlClient(payload)
        })
        this.$EventBus.$on('quit-click', () => {
            this.quitClick()
        })
        this.getHotGameList()
    },
    beforeDestroy() {
        this.$EventBus.$off('hide-search')
        this.$EventBus.$off('dl-client')
        this.$EventBus.$off('quit-click')
    },
    methods: {
        quitClick() {
            removeCookieToken()
            this.$store.commit('resetState')
        },
        getHotGameList() {
            const query = { page: 1, size: 4, type: 1 }
            getHotGameList(query).then((res) => {
                if (res.code == 200 && Array.isArray(res.data.list)) {
                    this.hotGameList = res.data.list.map((v) => {
                        let item = { ...v, cover_image_url: v.img, title: v.game_name, goods_id: 0 }
                        if (Array.isArray(item.boxGoodsList) && item.boxGoodsList[0]) {
                            item.goods_id = item.boxGoodsList[0].id
                            item.goods_name = item.boxGoodsList[0].name
                        }
                        return item
                    })
                }
            })
        },
        gameDatabase() {
            this.loading = true
            gameDatabase(this.query)
                .then(async (res) => {
                    this.loading = false
                    if (res.code == 200) {
                        this.loadingError = false
                        if (Array.isArray(res.data.list)) {
                            this.gameList = res.data.list
                            if (this.query.size > res.data.list.length) {
                                this.loadingFinish = true
                            }
                        }
                    } else {
                        this.loadingError = true
                    }
                })
                .catch(() => {
                    this.loading = false
                    this.loadingError = true
                })
        },
        changeNav(item) {
            this.$router.push(item.path)
        },
        handlerClickOutside() {
            this.showResult = false
        },
        handlerSearch(value) {
            this.showResult = true
            this.query.name = value
            if (value) {
                this.realSearch()
            } else {
                this.gameList = []
            }
        },
        resetSearchFilter() {
            this.query.name = ''
            this.gameList = []
        },
        realSearch() {
            cancelRequest('/box/boxFamily/gamefree/list')
            this.showResult = true
            this.gameList = []
            this.loading = false
            this.loadingFinish = false
            this.loadingError = false
            this.gameDatabase()
        },
        goToProfile() {
            if (!getCookieToken()) {
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 1 })
                const that = this
                return this.$Login.show({
                    scene: 'cb',
                    callback: function () {
                        that.$router.go(0)
                    }
                })
            } else {
                $('.common-bottom').hide()
                this.$router.push('/profile')
            }
        },
        validateFilename(filename) {
            const regex = /^LesuBox_(\d+\.\d+\.\d+(\.\d+)?)_([a-zA-Z0-9]+)_(\d+)\.exe$/
            return regex.test(filename)
        },
        dlClient(payload) {
            // 详情页底部"开始游戏"按钮或者是落地页的banner下载游戏，不走这里逻辑
            // 即：除了index页面顶部下载按钮，其他页面顶部下载按钮都会走到这里（盒子官网首页、游戏详情页、会员页面、游戏库页面）
            if (payload !== 'start-btn' && payload !== 'landpage-banner') {
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 2 })
            }
            // 通知到App.vue里面去下载
            this.$EventBus.$emit('app-dl')
        },
        handerFocus(value) {
            this.showResult = true
            this.query.name = value
            if (value) {
            } else {
                this.gameList = []
            }
        },
        // 下载福利活动点击
        actBenefitClick(type) {
            if (type === 1) {
                // 下福利点击
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 12 })
            } else {
                // 上福利点击
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 11 })
            }
            this.$store.commit('setMessageNum', 'ActBenefit')
            this.$ActSwitchDialog.show(1)
        },
        goToHowToPlay() {
            this.$router.push('/intro')
        },
        handlerClickSlide() {
            let item = this.swiperDataList[this.activeSwiperIndex]
            if (item.id === 1) {
                this.actBenefitClick(1)
            } else if (item.id === 2) {
                // 下福利点击
                this.$store.commit('setMessageNum', 'ActGroupBuyVip')
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 12 })
                this.$ActSwitchDialog.show(2)
            }
        },
        slideChangeTransitionStart() {
            this.activeSwiperIndex = this.swiperInstance.realIndex
        },
        openAct() {
            this.$ActSwitchDialog.show(2)
            // 上福利点击
            this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 11 })
            this.$store.commit('setMessageNum', 'ActGroupBuyVip')
        }
    }
}
</script>
<style lang="less" scoped>
.layout-comp {
    .hide {
        display: none;
    }
    &.game-style {
        height: calc(100% - 77px);
    }

    &.no-bottom {
        height: 100%;
    }

    .top-nav {
        position: fixed;
        z-index: 10;
        width: 1920px;
        left: 50%;
        transform: translateX(-50%);
        height: 80px;
        background: linear-gradient(180deg, #000000cc 0%, #00000000 100%);

        .nav-content {
            margin: 0 auto;
            width: 1320px;

            .left-sec {
                padding-top: 30px;

                & > span {
                    position: relative;
                    font-size: 16px;
                    color: #fff;
                    margin-right: 38px;
                    cursor: pointer;

                    &:last-child {
                        margin-right: 0;
                    }

                    &.active {
                        color: #00eb57;
                    }

                    .group-buy-sec {
                        position: absolute;
                        left: -40px;
                        top: 28px;
                        width: 180px;
                        height: 50px;
                        background: url(../../assets/pingtuan2.gif) center/100% no-repeat;
                    }
                }
            }

            .search-wrap {
                position: relative;
                margin-left: 41px;

                /deep/ .input-wrap {
                    margin: 22px auto 0;
                    height: 38px;
                    line-height: 38px;
                    background: url(../../assets/layout-input-bg.png) center/100% no-repeat;
                }

                .search-result {
                    position: absolute;
                    left: 0;
                    top: 67px;
                    width: 370px;
                    padding: 10px 20px;
                    height: 375px;
                    overflow-y: auto;
                    border-radius: 10px;
                    background: @bg-color-29;

                    .loading-wrap {
                        margin: 6px 0 4px;
                    }

                    .line {
                        margin: 10px 0;
                        height: 2px;
                        border-radius: 1px;
                        background-color: @bg-color-00;
                    }

                    .hot-inner {
                        .hot-title {
                            font-size: 14px;
                            line-height: 14px;
                            font-weight: bold;
                            color: @color-txt-high;
                            margin-bottom: 9px;
                        }
                    }
                }
            }

            .right-btn {
                margin-top: 22px;
                position: relative;
                .dl-btn {
                    .button-linear();
                    width: 125px;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                    font-weight: bold;
                    font-size: 16px;
                    color: @bg-color-00;
                }
                .act-top-icon {
                    position: absolute;
                    top: 36px;
                    left: 50%;
                    transform: translateX(-50%);
                    margin-left: -20px;
                    width: 212px;
                    height: 50px;
                    background-image: url(../../assets/act/ic_float_top.png);
                    background-repeat: no-repeat;
                    background-size: 212px 1300px;
                    animation: play 1s steps(26) infinite;
                    cursor: pointer;
                }

                @keyframes play {
                    from {
                        background-position: 0 0;
                    }
                    to {
                        background-position: 0 -1300px;
                    }
                }
            }

            .user-sec {
                position: relative;
                margin: 20px 0 0 30px;
                width: 40px;
                height: 40px;

                .user-avatar {
                    margin: 2px;
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    overflow: hidden;
                    cursor: pointer;

                    &.not-login {
                        background: #2b3631 url(../../assets/user_icon.png) center/16px 16px no-repeat;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .quit-bt {
                    display: none;
                    position: absolute;
                    top: 39px;
                    left: -20px;
                    text-align: center;
                    width: 80px;
                    height: 40px;
                    line-height: 40px;
                    font-size: 14px;
                    color: #fff;
                    border-radius: 10px;
                    cursor: pointer;
                    background-color: #1e1e1e;
                }

                &:hover {
                    .quit-bt {
                        display: block;
                    }
                }
            }

            .how-to-play {
                cursor: pointer;
                margin: 22px 24px 0 0;
                display: flex;
                width: 128px;
                height: 36px;
                justify-content: center;
                align-items: center;
                border-radius: 34px;
                border: 1px solid rgba(255, 255, 255, 0.2);
                color: rgb(255, 255, 255);
                font-size: 16px;

                &:hover {
                    border-color: rgba(255, 255, 255);
                }
            }
        }
    }

    .right-bottom-ads {
        position: fixed;
        z-index: 90;
        right: 45px;
        bottom: 30px;
        width: 220px;
        height: 220px;

        /deep/ .swiper-container {
            width: 100%;
            height: 100%;
            cursor: pointer;

            .swiper-slide {
                width: 220px;
                height: 220px;
            }
        }

        .get-free-game-act {
            width: 100%;
            height: 100%;
            background-image: url(../../assets/act/ic_float_box.png);
            background-repeat: no-repeat;
            background-size: 220px 5720px;
            animation: boxplay 1s steps(26) infinite;

            .tip {
                top: 35px;
                right: 28px;
            }

            @keyframes boxplay {
                from {
                    background-position: 0 0;
                }
                to {
                    background-position: 0 -5720px;
                }
            }
        }

        .group-buy-vip-act {
            position: relative;
            width: 100%;
            height: 100%;
            background: url(../../assets/pingtuan.gif) no-repeat;
            background-size: 190px 190px;
            background-position: center 32px;

            .tip {
                top: 58px;
                right: 40px;
            }
        }

        .swiper-pagination {
            display: flex;
            left: 50%;
            bottom: 10px;
            transform: translateX(-50%);
            z-index: 100;

            /deep/ .swiper-pagination-bullet {
                display: block;
                width: 11px;
                height: 2px;
                border-radius: 100px;
                background: #51716f;
                margin: 0 4px;
                cursor: pointer;

                &.swiper-pagination-bullet-active {
                    background: #00eb57;
                }
            }
        }

        .tip {
            position: absolute;
            display: flex;
            width: 24px;
            height: 16px;
            border-radius: 8px;
            border: 1px solid #fff;
            background: #ff2445;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 12px;
        }
    }
}
</style>
